import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ModalService } from 'src/app/shared/components/modal/modal.service';
import { RestService } from '../../../../../shared/utils/services/rest.service';
import { IGift } from 'src/app/core/models/user.model';

@Component({
  selector: 'app-new-item',
  templateUrl: './new-item.component.html',
  styleUrls: ['./new-item.component.scss']
})
export class NewItemComponent implements OnInit {

  @Input() data: any;

  public form: FormGroup;
  @ViewChild('image', { static: true }) image;

  constructor(
    private modalService: ModalService,
    private formBuilder: FormBuilder,
    private restService: RestService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      image: [this.data ? this.data.imageName : '', Validators.required],
      description: [this.data ? this.data.description : '', Validators.required],
      limitQuantity: [this.data ? this.data.limitQuantity : '', Validators.required]
    });
  }

  public onClose(status?): void {
    this.modalService.closeModal(status);
  }

  fileChange(event) {
    // const file = event.files[0];
    // const formData = new FormData();
    // formData.append('file', file);
    console.log(event.target.files[0]);

    // this.http.post('http://localhost:4200', formData)
    //   .subscribe(result => console.log('ok')
    //   );

      // this.renderer2.setAttribute(this.image, 'innerHTML', file[0].name)

    // const fileReader = new FileReader();
    // fileReader.onloadend = function() {
    //   console.log(fileReader.result);
    // };

    // fileReader.readAsDataURL(file);
  }

  onSubmit() {
    const newItem: IGift = {
      description: this.form.value.description,
      image: this.form.value.image,
      confirmedQuantity: this.data && this.data.isEdit ? this.data.confirmedQuantity : 0,
      limitQuantity: this.form.value.limitQuantity,
      status: true
    }
    if (this.data && this.data.isEdit) {
      console.log('Item atualizado: ', newItem);
      this.restService.updateItem(newItem, this.data.key, true);
    } else {
      console.log('Novo item adicionado: ', newItem);
      this.restService.setItem(newItem);
    }
    this.onClose(this.form.value);
  }
}